import styled from 'styled-components';

export const StyledRegisteredAppointmentsChart = styled.div`
   height: 138px;
   width: 100%;
   margin-top: 12px;
`;
StyledRegisteredAppointmentsChart.displayName = 'StyledRegisteredAppointmentsChart';
